<template>
  <v-row>
    <v-col cols="12">

      <v-sheet
        width="100%"
        outlined>
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Avtividad:</h3>
          </v-col>

          <v-col cols="12" xl="8" md="8" sm="8" xs="12">
            <v-text-field
              ref="name"
              v-model="name"
              outlined
              :maxlength="100"
              :counter="100"
              :rules="[v => (v || '' ).length <= 99 || 'El nombre del día no debe tener mas de 100 caracteres']"
              label="Nombre del día"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-text-field
              type="date"
              v-model="date"
              outlined
              append-icon="mdi-calendar"
              label="Fecha de la actividad"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_btn"
        color="primary"
        :to="{ name: 'programEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_btn"
        :disabled="!date"
        color="primary"
        @click="saveDayProgram()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'newDayProgramEdition',

    data: () => ({
      loading_btn: false,
      edition_id:null,

      name:null,
      date:null,

      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ]
    }),

    methods:{
      async saveDayProgram()
      {
        this.loading_btn = true
        let formData= new FormData()
        if(this.name){
          formData.append('name', this.name)
        }
        if(this.date){
          formData.append('date', this.date);
        }
        formData.append('edition_id', this.edition_id)
        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/program-edition',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.loading = true
            this.$router.push({ name: 'programEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          this.dialog_new_edition = false
          this.loading_btn = false
          console.error(error.response.data);
        }
      }
    },
    created(){
      this.edition_id = this.$route.params.edition_id
    },
  }
</script>
